<template>
    <table-td justifyContent="options.align">
        {{ model }}
    </table-td>
</template>

<script>
    import TableTd from "../../component/part/TableTd";
    import FormTableBaseText from "../FormTableBaseText";

    export default {
        name: "FormTableMpsText",
        extends: FormTableBaseText,
        components: {TableTd},
    }
</script>

<style scoped>

</style>